/*jslint es6*/
import RelationshipQuery from "@arcgis/core/rest/support/RelationshipQuery";
import esriRequest from "@arcgis/core/request";
import config from "../assets/config.json";
const cleanupsHeader = `<div style="background-color:#356595;color:#feffff;">
<h2>
    <span style="color:#d5dcdc;">Cleanups</span>
</h2>
</div>`;
const brownfieldHeader = `<div style="background-color:#74574c;color:#ffffff;">
<h2>
    <span style="color:#ffffff;">Brownfields Grants</span>
</h2>
</div>`;

export function buildBrownfieldsPopup(webmap) {
    // const brownfieldLayer = webmap.layers.find(e => e.title === "Brownfield Grant Jurisdictions");
    const brownfieldLayer = webmap.layers.find(
        (e) => e.allLayers && e.allLayers.items.find(
          (p) => p.title === config.layerNames.brownfieldLayer.title
          )
        )
        .allLayers.items.find(
          (p) => p.title === config.layerNames.brownfieldLayer.title
          )
        ;
    brownfieldLayer.popupTemplate = {
        title: '{JURISDICTION_NAME}',
        content: [{
            type: 'custom',
            creator: (async (event) => {
                let objectID = event.graphic.attributes.OBJECTID;
                // string that will eventually make up the entire html snippet to be used for the popup. begin it with the cleanups header and brownfields header
                let grantString = `${cleanupsHeader}${brownfieldHeader}<div>`;
                let categorizedElements = {};
                let query = new RelationshipQuery({
                    objectIds: objectID,
                    relationshipId: 0,
                    outFields: ['GRANT_TYPE', 'RECIPIENT_NAME', 'COOPERATIVE_AGREEMENT_PC', 'GRANT_ID']
                });

                await brownfieldLayer.queryRelatedFeatures(query)
                    .then((results) => {
                        // returns an object with 1 definition
                        for (let result in results) {
                            // grantString += `<div><h4>${results[result].features[0].attributes.JURISDICTION_NAME}</h4></div>`;
                            results[result].features.forEach((grant) => {
                                // // https://cimc.epa.gov/ords/cimc/f?p=CIMC:19::::0:P0_GRANT_ID:
                                let grantType = grant.attributes.GRANT_TYPE;
                                let linkText = `https://cimc.epa.gov/ords/cimc/f?p=CIMC:19::::0:P0_GRANT_ID:${grant.attributes.GRANT_ID}`;
                                let element = `<div><a href = '${linkText}'>${grant.attributes.RECIPIENT_NAME} - ${grant.attributes.COOPERATIVE_AGREEMENT_PC}</a></div>`;
                                if (categorizedElements[grantType] === undefined) {
                                    categorizedElements[grantType] = `<div><h4>${grantType}</h4></div>`;
                                }
                                categorizedElements[grantType] += element;
                            });
                        }

                        for (let category in categorizedElements) {
                            grantString += categorizedElements[category];
                        }
                        grantString += `</div>`;
                    })
                return grantString;
            })
        }]
    };
}

export function buildRCRABoundariesPopup(webmap) {
    // const boundariesLayers = webmap.layers.find(e => e.title === 'RCRA Boundaries');
    const boundariesLayers = webmap.layers.find(
        (e) => e.allLayers && e.allLayers.items.find(
          (p) => p.title === config.layerNames.rcra.title
          )
        )
        .allLayers.items.find(
          (p) => p.title === config.layerNames.rcra.title
          )
        ;
    // create a popup for each sublayer
    boundariesLayers.layers.items.forEach((layer) => {
        layer.load()
            .then(() => {
                layer.popupTemplate = {
                    content: [{
                        type: 'custom',
                        creator: (async (event) => {
                            // query for handler id to use for retrieving data from ords
                            let objectInfo = {};
                            await layer.queryFeatures({
                                    objectIds: [event.graphic.attributes.OBJECTID],
                                    outFields: ['HANDLER_ID', 'HANDLER_NAME', 'AREA_NAME', 'LOCATION_STREET1', 'LOCATION_CITY', 'LOCATION_COUNTY', 'LOCATION_ZIP',
                                        'LOCATION_STATE'
                                    ]
                                }).then((results) => {
                                    objectInfo = {
                                        handlerId: results.features[0].attributes.HANDLER_ID,
                                        handlerName: results.features[0].attributes.HANDLER_NAME,
                                        areaName: results.features[0].attributes.AREA_NAME,
                                        street: results.features[0].attributes.LOCATION_STREET1,
                                        city: results.features[0].attributes.LOCATION_CITY,
                                        county: results.features[0].attributes.LOCATION_COUNTY,
                                        zip: results.features[0].attributes.LOCATION_ZIP,
                                        state: results.features[0].attributes.LOCATION_STATE
                                    }
                                })
                                .catch((e) => {
                                    console.error('error retrieving object information: ', e)
                                });
                            // now retrieve data from ords
                            // this url will need to be pointed somewhere else and moved into a config file eventually
                            const url = `https://ordspub.epa.gov/ords/cimc_dws/cimc_patdws_apex/GET/CIMCWS/${objectInfo['handlerId']}`;
                            let ordspubData = {};
                            await esriRequest(url, {
                                responseType: 'json'
                            }).then((results) => {
                                // this data might be different than what the original version gets currently,
                                // original retrieves data that has a .controls attribute and this response is structured differently
                                ordspubData = {
                                    engineeringGW: results.data.EC_GW.length > 0 ? 'YES' : 'NO',
                                    engineeringNG: results.data.EC_GW.length > 0 ? 'YES' : 'NO',
                                    institutionEP: results.data.IC_EP.length > 0 ? 'YES' : 'NO',
                                    institutionGC: results.data.IC_GC.length > 0 ? 'YES' : 'NO',
                                    institutionID: results.data.IC_ID.length > 0 ? 'YES' : 'NO',
                                    institutionPR: results.data.IC_PR.length > 0 ? 'YES' : 'NO'
                                };
                            });
                            // console.log('ordspubData: ', ordspubData);
                            // now need to make html elements with objectInfo and ordspubData;

                            const contentString = `<div><h4>${objectInfo['handlerName']}</h4></div>
                                <div><p>
                                <strong>Street Address:</strong> ${objectInfo['street']}<br>
                                <strong>City:</strong> ${objectInfo['city']}<br>
                                <strong>Zip:</strong> ${objectInfo['zip']}<br>
                                <strong>EPA ID#:</strong> ${objectInfo['handlerId']}<br>
                                <a href = "${ordspubData['PROFILE_URL']}" rel="nofollow ugc noopener noreferrer" target="_blank"> RCRA Corrective Action Profile</a><br>
                                </p></div>
                                <div><p>
                                Is ${objectInfo['areaName']} subject to:<br>
                                <b><u>Engineering Control</u></b><span class="rollover"> </span><br/>
                                Groundwater Control (CA770GW)? <strong>${ordspubData['engineeringGW']}</strong><br>
                                Non-Groundwater Control (CA770NG)? <strong>${ordspubData['engineeringNG']}</strong><br>
                                <b><u>Institutional Control</u></b><span class="rollover"> </span><br/>
                                Proprietary Control (CA772PR)? <strong>${ordspubData['institutionEP']}</strong><br>
                                Order or permit (CA772EP)? <strong>${ordspubData['institutionGC']}</strong><br>
                                Government Control (CA772GC)? <strong>${ordspubData['institutionID']}</strong><br>
                                Information Device (CA772ID)? <strong>${ordspubData['institutionPR']}</strong><br>
                                </p></div>
                                `;
                            return contentString;
                        })
                    }]
                }
            })
    });
}
   export function buildSitesPopup(webmap) {
    const sitesLayer = webmap.layers.find(
        (e) => e.allLayers && e.allLayers.items.find(
          (p) => p.title === config.layerNames.sitesLayer.title
          )
        )
        .allLayers.items.find(
          (p) => p.title === config.layerNames.sitesLayer.title
          )
        ;;
    sitesLayer.popupTemplate = {
        title: '{PRIMARY_NAME}',
        content: [{
            type: 'custom',
            creator: async (event) => {
                let mapSymbolElement = ``;
                if (event.graphic.attributes.MAP_SYMBOL_CODE) {
                    mapSymbolElement = `<div><img src="https://raw.githubusercontent.com/ntnpgs/cimcSymbology/main/cimcSitesSymbols/${event.graphic.attributes.MAP_SYMBOL_CODE}.png"/></div>`
                }
                // const mapCode = event.graphic.attributes.MAP_SYMBOL_CODE;
                // const imageUrl = `https://raw.githubusercontent.com/ntnpgs/cimcSymbology/main/cimcSitesSymbols/${mapCode}.png`;

                // site popups when searching by EPA facility registry do not retrieve the site symbology
                // MNN000510369 has a bad image for example
                // get necessary data to construct popup
                const query = sitesLayer.createQuery();
                query.outFields = ['EPA_ID', 'FD_FEDERAL_AGENCY', 'FD_NON_NPL_STATUS_NAME',
                    'FD_NPL_STATUS_NAME', 'FD_BRAC_ROUND', 'REGISTRY_ID', 'SF_SITE_ID',
                    'FD_SF_SITE_ID', 'RCRA_HANDLER_ID', 'REGISTRY_ID', 'REPOW_REF_KEY', 'EPAOSC_SITE_ID',
                    'BF_PROPERTY_ID', 'Census_URL', 'ACS_URL', 'EPA_REGION_CODE', 'RCRA_DRUPAL_SITE_NODEID', 'RCRA_DRUPAL_DOC_NODEID'
                ];
                query.returnGeometry = false;
                query.objectIds = [event.graphic.attributes.OBJECTID];
                let siteData;
                await sitesLayer.queryFeatures(query)
                    .then((results) => {
                        siteData = results.features[0].attributes;
                    });
                // console.log('siteData: ', siteData);
                let contentString = ``;
                // create links and information elements based on data retrieved about the site
                if (siteData.EPA_ID) {
                    contentString += `<div><strong>EPA ID:</strong> ${siteData.EPA_ID}</div>`;
                }
                if (siteData.FD_FEDERAL_AGENCY) {
                    contentString += `<div><strong>Agency:</strong> ${siteData.FD_FEDERAL_AGENCY}</div>`;
                }
                if (siteData.FD_NON_NPL_STATUS_NAME) {
                    contentString += `<div><strong>Non-NPL Status:</strong> ${siteData.FD_NON_NPL_STATUS_NAME}</div>`;
                }
                if (siteData.FD_NPL_STATUS_NAME) {
                    contentString += `<div><strong>NPL Status:</strong> ${siteData.FD_NPL_STATUS_NAME}</div>`;
                }
                if (siteData.FD_BRAC_ROUND) {
                    contentString += `<div><strong>BRAC Round:</strong> ${siteData.FD_BRAC_ROUND}</div>`;
                }
                if (siteData.REGISTRY_ID) {
                    contentString += `<div><a target="_blank" rel="noopener noreferrer" href="https://frs-public.epa.gov/ords/frs_public2/fii_query_detail.disp_program_facility?p_registry_id=${siteData.REGISTRY_ID}">FRS Profile</a></div>`;
                }
                if (siteData.SF_SITE_ID) {
                    contentString += `<div><a target="_blank" rel="noopener noreferrer" href="https://cumulis.epa.gov/supercpad/cursites/csitinfo.cfm?id=${siteData.SF_SITE_ID}">Superfund Site Home</a></div>`;
                } else if (siteData.FD_SF_SITE_ID) {
                    contentString += `<div><a target="_blank" rel="noopener noreferrer" href="https://cumulis.epa.gov/supercpad/cursites/csitinfo.cfm?id=${siteData.FD_SF_SITE_ID}">Superfund Site Home</a></div>`;
                }
                if (siteData.RCRA_HANDLER_ID) {
                    if (siteData.EPA_REGION_CODE === '03') {
                        contentString += `<div><a target="_blank" rel="noopener noreferrer" href="${siteData.RCRA_DRUPAL_SITE_NODEID}">RCRA Corrective Action Profile</a></div>`;
                    } else {
                        contentString += `<div><a target="_blank" rel="noopener noreferrer" href="https://ordspub.epa.gov/ords/cimc/f?p=CIMC:RCRA:::::P14_RCRA_HANDLER_ID:${siteData.RCRA_HANDLER_ID}">RCRA Corrective Action Profile</a></div>`;
                    }
                }
                if (siteData.REGISTRY_ID) {
                    contentString += `<div><a target="_blank" rel="noopener noreferrer" href="https://echo.epa.gov/detailed-facility-report?fid=${siteData.REGISTRY_ID}">Enforcement &amp; Compliance</a></div>`
                }
                if (siteData.REPOW_REF_KEY) {
                    contentString += `<div><a target="_blank" rel="noopener noreferrer" href="https://ofmpub.epa.gov/apex/cimc/f?p=CIMC:REPOWER:0::::P6_REFERENCE:${siteData.REPOW_REF_KEY}">Re-Powering Site Profile</a></div>`;
                }
                if (siteData.BF_PROPERTY_ID) {
                    contentString += `<div><a target="_blank" rel="noopener noreferrer" href="https://cimc.epa.gov/ords/cimc/f?p=CIMC:31::::Y,31:P31_ID:${siteData.BF_PROPERTY_ID}">Brownfields Property Profile</a></div>`;
                }
                if (siteData.EPA_REGION_CODE === '03') {
                    contentString += `<div><a href="${siteData.RCRA_DRUPAL_DOC_NODEID}">RCRA Region 3 Documents</a></div>`;
                }
                if (siteData.Census_URL || siteData.ACS_URL) {
                    contentString += `<div><strong>Census Profiles:</strong></div>`;
                }
                if (siteData.Census_URL) {
                    contentString += `<div><a href="${siteData.Census_URL}" rel="nofollow ugc noopener noreferrer" target="_blank">Census 2010 1 Mile Report (PDF)</a></div>`;
                }
                if (siteData.ACS_URL) {
                    contentString += `<div><a href="${siteData.ACS_URL}" rel="nofollow ugc noopener noreferrer" target="_blank">Census 2013-2017 - 1 Mile (PDF)</a></div>`;
                }

                // return `
                // ${cleanupsHeader}
                // <div><img src="${imageUrl}" /></div>
                // ${contentString}
                // `;
                return `
                ${cleanupsHeader}
                ${mapSymbolElement}
                ${contentString}
                `;
            }
        }]
    }
}